import { useEffect } from "react";

/**
 * Der Titel im Browserfenster - und damit der Eintrag im Verlauf.
 *
 * In einer Einzelseiten-Anwendung wechselt die Adresse, ohne dass eine
 * neue Seite geladen wird. Der Titel aus der index.html bleibt deshalb
 * stehen, und im Verlauf steht zwanzigmal „Stammbaum" untereinander -
 * man sieht die Adresse, aber nicht, wer dahintersteckt.
 *
 * Darum setzt jede Seite ihren eigenen Titel, und zwar in zwei Schritten:
 * sofort etwas aus der Adresse („Person 70"), und sobald die Daten da
 * sind, der Name. Chrome übernimmt eine spätere Änderung in den schon
 * angelegten Verlaufseintrag; ein Eintrag ohne Namen entsteht also nur,
 * wenn gar nichts geladen werden konnte.
 *
 * Das Unterscheidende steht vorn: im Verlauf und in der Fensterleiste
 * ist nach dreißig Zeichen Schluss, und „Stammbaum — Huber Maria" wäre
 * dort wieder zwanzigmal dasselbe.
 */
const BASIS = "Stammbaum";

export function useTitel(teil?: string | null) {
  useEffect(() => {
    document.title = teil ? `${teil} · ${BASIS}` : BASIS;
    // Beim Verlassen zurück auf den schlichten Titel: sonst hinge der
    // Name der zuletzt geöffneten Person an der nächsten Seite, die
    // selbst keinen setzt.
    return () => {
      document.title = BASIS;
    };
  }, [teil]);
}

/**
 * „Huber Maria (70)" - Familienname zuerst, wie in der Überschrift der
 * Personenseite und in der Trefferliste. Die Nummer steht dabei, weil es
 * den Josef Huber dreimal gibt und der Verlauf sonst nicht weiterhilft.
 */
export function personTitel(
  p: { vorname?: string | null; famname?: string | null } | null | undefined,
  id: number,
): string {
  const name = `${p?.famname ?? ""} ${p?.vorname ?? ""}`.trim();
  return name ? `${name} (${id})` : `Person ${id}`;
}
